import React, { Component } from 'react';

import pic from './400.jpg'
import card1 from './card1.jpg';

import card3 from './card3.jpg';
import ic from './museums.png';
import Slider from 'react-slick';
import Sliders from 'react-slick';
import c1 from './1.jpg';
import c2 from './2.jpg';
import c3 from './3.jpg';
import g1 from './grid1.jpg'
import g2 from './grid2.jpg'
import g3 from './grid3.jpg'
import g4 from './grid4.jpg'

import pack1 from './pack1.jpg';
import pack2 from './pack2.jpg';
import './App.css';
import { Layout, Menu, Icon,Carousel,Card, Col, Row , Button, Dropdown,Steps,Rate,Spin} from 'antd';
import Img from 'react-image';
import MediaQuery from 'react-responsive';
import Coverflow from 'react-coverflow';
import AutoResponsive from 'autoresponsive-react';
import {storage, ref,str} from './constants';
import { Link } from 'react-router/lib';
import {connect} from 'react-redux';
import {createSelectPackage} from './reducers.js'
const Step =Steps.Step;

const { Header, Sider, Content,Footer } = Layout;
const data=[];
const titles=['Double Bed AC','Double Bed Non AC','Single Bed AC','Single Bed Non AC']
const price=['3200','2800','2500','2000']
const desc= ['Delux AC','Delux Non AC','Budget AC','Budget Non AC'];
const pack_title=['Premium Wayanad Package','Budget Wayanad Package'];
const pack_desc =['Offer for 4 Adults and 2 kids','Offer for 2 Adults and 1 kids'];
const pack_price = ['10999','8999'];
class App extends Component {

  constructor(props){
    super(props);
    this.styles = {
      root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
      },
      gridList: {
        width: 'auto',
        height: 250,
        overflowY: 'auto',
        marginTop:20
      },
    };
    this.state = {
      collapsed: true,
      dataList:[],
      data:[],
      load:true,
    };

  }


  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }
componentDidMount(){
  this.fetchData();
}
fetchData(){
    var self = this;
    var fileList = [];
    ref.child('data/room').once('value')
      .then(function(snapshot){
        snapshot.forEach(function(child){
          var data={
            desc:'',
            title:'',
            cover:'',
            cost:'',
          }
          data.desc = child.val().desc;
          data.title = child.val().title
          data.cover = child.val().cover
          data.cost = child.val().price
          fileList.push(data);
        })
        self.setState({dataList:fileList,load:false})
        console.log("data aagaya",fileList);

      })
}

getAutoResponsiveProps() {
    return {
      itemMargin: 10,

      itemClassName: 'item',
      gridWidth: 100,
      transitionDuration: '.5'
    };
}
cat(i){

  const file = this.state.dataList[i];

  const data ={
    type:'room',
    no:'',
    price:'',
    title:'',
    desc:'',
  }
  data.no = i;
  data.price = file.cost;
  data.title = file.title;


  this.props.onPackageSelect(data);
  //this.setState({data:data})
  console.log("asdasdajkj",data);
  //http://unsplash.it/1400/400?random
}
pak(i){
  const data ={
    type:'pack',
    no:'',
    price:'',
    title:'',
    desc:'',
  }

  if(i%2==0){
    data.no=0;
    data.type='pack'
    data.price = pack_price[0];
    data.title = pack_title[0];
    data.desc = pack_desc[0];
  }
  else{
    data.no=1;
    data.price = pack_price[1];
    data.title = pack_title[1];
    data.desc = pack_desc[1];
  }
  this.props.onPackageSelect(data);

}
  render() {
    const gl = [g1,g2,g3,g4];
    const fileList = this.state.dataList;
    const pacList = this.state.dataList;
    const packItems = [];
    for(let i = 0; i<fileList.length;i++ ){
      packItems.push(
        <Link to="/pack">
          <Card onClick={this.cat.bind(this,i)}  bordered={true} style={{height:250,width:230,marginTop:10,borderColor:''}} bodyStyle={{ padding: 1 }}><div class="container"><img class="image" src={gl[i]} width="100%" />
          <div style={{display:'flex',flexDirection:'row' ,marginTop:20,marginLeft:10,marginRight:5}}>
            <div style={{display:'flex',flexDirection:'column',width:'80%',display: 'block',overflow: 'hidden',whiteSpace: 'nowrap',textOverflow: 'ellipsis',color:'black'}}>
              <h3>{fileList[i].title}</h3>
              {fileList[i].desc}
            </div>
            <div style={{display:'box',borderRadius:5,backgroundColor:'#1DA57A',width:'auto',height:'50%',color:'#ffffff',padding:8}}>
              ₹{fileList[i].cost}
            </div>

          </div></div></Card>
        </Link>
      )
    }

    const loadingItems=[];
    for(let i=0;i<4;i++){
      loadingItems.push(
        <Card loading  bordered={true} style={{height:250,width:230,marginTop:10,borderColor:''}} bodyStyle={{ padding: 1 }}></Card>
      )
    }

    const m = [pack1,pack2,pack1,pack2]

    const slidePack =[]

    for(let i=0;i<4;i++){
      slidePack.push(
        <div style={{padding:10,}}>
          <Link to="/pack">
            <Card onClick={this.pak.bind(this,i)} bordered={false}  bodyStyle={{ padding: 1 }}><div class="container"><img class="image" src={card1} width="100%" />
              <div style={{display:'flex',flexDirection:'row' ,marginTop:20,marginLeft:10,marginBottom:5}}>
                <div style={{display:'flex',flexDirection:'column',width:'80%',display: 'block',overflow: 'hidden',whiteSpace: 'nowrap',textOverflow: 'ellipsis',padding:5,color:'black'}}>
                  <h2>{i%2==0?pack_title[0]:pack_title[1]}</h2>
                  {i%2==0?pack_desc[0]:pack_desc[1]}
                </div>
                <div style={{display:'box',borderRadius:5,backgroundColor:'#1DA57A',width:'auto',height:'50%',color:'#ffffff',padding:8}}>
                  ₹{i%2==0?pack_price[0]:pack_price[1]}
                </div>

              </div>
            </div></Card>
          </Link>
        </div>
      )
    }


const items=[];
const l =[c1,c2,c3];

    for(let i =0; i<3;i++){
      items.push(<div><Img src={l[i]} style={{width:'100%'}} loader={<div style={{padding:10,margin:'auto',width:'100%',textAlign:'center'}}><Spin size="large" /></div>}/></div>)
    }



  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    autoplay:true,
    centerMode: true,
    centerPadding: '40px',
    responsive: [
    {
      breakpoint: 2024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        infinite: true,
        speed: 500,
        centerMode: true,
        centerPadding: '40px',
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        infinite: true,
        speed: 500,
        centerMode: true,
        centerPadding: '40px',
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        speed: 500,
        centerMode: true,
        centerPadding: '40px',
      }
    },
    {
      breakpoint: 100000,
      settings:'unslick'
    }
  ]
  };
  /**/

  var settings_slider = {
      dots: true,
      autoplay:true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
    };

    return (
      <div >


          <Layout >
            <Content style={{marginTop:31}}>
              <Sliders {...settings_slider}>
                {items}
              </Sliders>
            </Content>
          <Content style={{background: '#fff', minHeight:280 }}>
          <br />

            {/*<div style={{display:'flex',justifyContent:'center'}}>
              <AutoResponsive ref="container" {...this.getAutoResponsiveProps()}>
                {packItems}
              </AutoResponsive>
            </div>*/}
            <Content style={{margin:60,}}>
              <div id="Rooms" style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                <div><h1>Rooms</h1></div>
                <div style={{background:'#0792EF',width:'5%',height:1,marginTop:2}}/>
              </div>
              <br />
              <div style={{width:'80%',margin:'auto'}}>



                <MediaQuery minDeviceWidth={726}>
                  <div style={{display:'flex',flexDirection:'row',flexWrap:'wrap',justifyContent:'space-around'}}>
                    {this.state.load?loadingItems:packItems}
                  </div>
                </MediaQuery>

                <MediaQuery maxDeviceWidth={726}>

                  <div style={{display:'flex',flexDirection:'column',flexWrap:'wrap',justifyContent:'space-around',alignItems:'center'}}>
                    {this.state.load?loadingItems:packItems}
                  </div>
                </MediaQuery>

                  <div style={{marginTop:20,textAlign:'center'}}>
                    <Button type="primary" size="large" >Explore</Button>
                  </div>
              </div>
            </Content>
          {/*
            */
}

            <br />
            <div id="Packages" style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
              <div><h1>Packages</h1></div>
              <div style={{background:'#0792EF',width:'5%',height:1,marginTop:2}}/>
            </div>
            <br />



            <div style={{ background: '#2E2C2D', padding: '30px'  }}>

              <div style={{marginTop:30}}>

              </div>
              <Slider {...settings} style={{margin:30,}}>

                {slidePack}
              </Slider>
              <br/>
              <br/>
              <div style={{textAlign:'center'}}>
              <Button type="primary">View All</Button>

              </div>
            </div>

            <br />




          </Content>


          </Layout>




      </div>
    );
  }
}
const mapDispatchToProps = (dispatch)=>(
  {
    onPackageSelect:(data)=>{
      dispatch(createSelectPackage(data));
    }
  }
)
export default connect(null,mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/App.js